<template>
  <div id="list">
    <!-- <div>
      <b-button v-b-toggle.collapse-1 variant="primary">Toggle Collapse</b-button>
      <b-collapse id="collapse-1" class="mt-2">
        <b-card>
          <p class="card-text">Collapse contents Here</p>
          <b-button v-b-toggle.collapse-1-inner size="sm">Toggle Inner Collapse</b-button>
          <b-collapse id="collapse-1-inner" class="mt-2">
            <b-card>Hello!</b-card>
          </b-collapse>
        </b-card>
      </b-collapse>
    </div> -->
    <!-- <div id="status"></div> -->
    <paginate
      :page-count="getPageCount"
      :page-range="3"
      :margin-pages="6"
      :click-handler="clickCallback"
      :prev-text="'＜'"
      :next-text="'＞'"
      :container-class="'pagination'"
      :page-class="'page-item'">
    </paginate>
    <div class="container-fluid">
      <div class="row all-display">
        <!-- <div class="col-md-2 text-break primary" v-for="(item, index) in tree" :key="index">
          {{ item.JSON }}
        </div> -->
        <!-- <div v-if="!is_ethereum">
          Please connect your ethereum wallet, if you want to communicate with them.
        </div> -->

        <!-- <ul>
          <li v-for="item in getItems">{{item.name}}</li>
        </ul> -->

        <div class="col-sm-4 col-md-3 col-lg-2 text-break primary" v-for="(item, index) in getItems" :key="index" style="vertical-align: baseline;">
          <router-link class="item-list" :to="{name: 'Detail', query: {id: item.index}}">
          <div class="item rounded">
            <p><b>{{ item.name }}</b></p>
          <div class="image" >
              <p class="SvgImage"><img v-bind:src="item.image" style="display: block; margin: auto;"></p>
          </div>
          <div v-if="item.owner=='null'">
            <p class="price"><b>Price:</b> 0.02 ETH</p>
            <!-- <button class="btn btn-list btn-warning" v-on:click="buy2($event, item.address)"  v-if="is_ethereum">BUY NOW</button> -->
          </div>
            <!-- <div class="item rounded">
              <p style="text-align:center"><b>{{ item.name }}</b></p>
              <p><b>Address:</b> {{ item.address }} </p>
              <p><b>Parent address:</b> {{ item.address }} </p>
              <p><b>Number of children:</b> 0 </p>
              <p><b>Balance:</b> {{ item.balance }} ETH</p>
              <div>
                <input type="text" id="value" name="value" required size="10" v-model="txtInput" @keyup.enter="deposit"> ETH
                <button class="btn btn-primary" v-on:click="deposit2($event, item.address)" >Deposit</button>
              </div>
            </div> -->


            <!-- detailed information tab -->
            <!-- <b-button v-b-toggle="'collapse' + index"></b-button>
            <b-collapse v-bind:id="'collapse' + index" class="mt-2">
              <b-card>
                <p><b>Address:</b> {{ item.address }} </p>

                <p v-if="item.parent!=null"><b>Parent:</b> #{{ item.parent }} </p>

                <p v-if="item.children[0]!=null">
                  <b>Children:</b>
                  <li v-for="(child, index) in item.children" :key="index">
                    #{{ child }}
                  </li>
                </p>
                <p><b>Balance:</b> {{ item.balance }} ETH</p>

                <div v-if="is_ethereum">
                  <p>
                    <input type="text" id="value" name="value" placeholder="ETH" required size="8" v-model="txtInput" @keyup.enter="deposit2">
                    <button class="btn btn-primary" v-on:click="deposit2($event, item.address)" >Feed</button>
                  </p>
                <div v-if="item.owner=='null'">
                  <p><b>Price:</b> 0.02 ETH</p>
                  <button class="btn btn-primary" v-on:click="buy2($event, item.address)" >BUY</button>
                </div>
                <div v-else>
                  <p><b>Token Owner:</b> {{ item.owner }}</p>
                </div>
              </div>
              </b-card>
            </b-collapse> -->

          </div>
          </router-link>
        </div>
        <paginate
          :page-count="getPageCount"
          :page-range="3"
          :margin-pages="6"
          :click-handler="clickCallback"
          :prev-text="'＜'"
          :next-text="'＞'"
          :container-class="'pagination'"
          :page-class="'page-item'">
        </paginate>

      </div>
    </div>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate'
import Web3Util from "../web3_util.js"
import db from "../firebase.js"

export default {
  name: 'list',
  components: {
    Paginate,
  },
  data () {
    return {
      data: [],
      items: [],
      txtInput: null,
      parPage: 24,
      currentPage: 1,
      is_ethereum: false
    }
    // return {
    //   items: ["waiting for load items"], //item-gridコンポーネントにアセット情報を渡す箱
    //   index: 0,//謎
    //   //アドレスを入力してアセット一覧を取ってくる際の入れ物
    //   walletAddress: "0x9c36edd80831f7e0d95131c076ef918b056967cf",　　
    //   msg: 'ALTERNATIVE MACHINE'
    // }
  },
  mounted: async function () {

    db.collection("info")
      .orderBy('index', 'desc')
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // console.log(`${doc.id} => ${doc.data().image}`)
          this.data.push(doc.data())
        })
      })
    this.is_ethereum = await Web3Util.load();
  },
  methods: {
    clickCallback: function (pageNum) {
       this.currentPage = Number(pageNum);
    },
    deposit2: function (event, address) {
      console.log(address)
      Web3Util.deposit(address, this.txtInput);//133238529999900
      // if (event) {
      //   alert(event.target.tagName)
      // }
    },
    buy2: function (event, address) {
      console.log(address)
      Web3Util.buy(address, this.txtInput);
    }
  },
  computed: {
     getItems: function() {
       let current = this.currentPage * this.parPage;
       let start = current - this.parPage;
       return this.data.slice(start, current);
     },
     getPageCount: function() {
       return Math.ceil(this.data.length / this.parPage);
     }
   }
  // mounted: async function(){
  //   console.log("mounted")//デバッグ用
  //   // this.items = await poke()
  // },
}

</script>

<style>
#list {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 40px;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

/* a {
  color: #42b983;
} */

.all-display .col-md-3 {
  padding: 10px 10px;
  text-align: left;
}

.all-display .col-md-2 {
  padding: 10px 10px;
  text-align: left;
}

.all-display {
  margin: 0px 5px;
}

.item {
  padding: 10px 15px;
  border: 1px solid #000000;
  border-color: rgb(200,200,200,.7);
  /* height: 300px; */
  /* width: 100%; */
  height: 100%;
}

.item:hover {
  padding: 10px 15px;
  border: 1px solid #000000;
  border-color: rgb(100,100,200,.7);
  /* height: 300px; */
  /* width: 100%; */
  height: 100%;
}

.image {
  display: flex;
  flex-flow: column;
  flex-direction: column;
  flex-wrap: initial;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  width: 100%;
  height: 250px;
}

.SvgImage img{
  height: auto;
  max-height: 250px;
  max-width: 100%;
  width:100%;
}

/* .paginate {
  text-align: center;
} */

.pagination {
  display: flex;
  justify-content: center;
}


.btn-list{
  font-weight: bold;
  font-size: 10px;
  color: white;
  padding: 0;
}

a.item-list{
  color: black;
  text-decoration: none;
}

p.price{
  font-size: 14px;
  padding: 0;
  margin: 0;
}

/* a:hover.item-list{
  color: red;
  text-decoration: none;
} */

/* a.page-item:hover{
  background-color: gold;
} */

</style>



// WEBPACK FOOTER //
// src/components/List.vue